import { ref, onMounted, onUnmounted, computed } from 'vue';

const DEFAULT_HEIGHT_PERCENTAGE = 0.4;

export function useDynamicHeight(heightPercentage: number = DEFAULT_HEIGHT_PERCENTAGE) {
  const windowHeight = ref(window.innerHeight);

  function updateWindowHeight() {
    windowHeight.value = window.innerHeight;
  }

  onMounted(() => {
    window.addEventListener('resize', updateWindowHeight);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateWindowHeight);
  });

  const dynamicHeight = computed(() => windowHeight.value * heightPercentage);

  return { dynamicHeight };
}
